module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp-brk",
    attrs: {
      "id": "ch4"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cn"
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("FOUR")])]), _vm._v(" "), _c('p', {
    staticClass: "co"
  }, [_c('span', {
    staticClass: "epub-sans-caps-i"
  }, [_vm._v("“H")]), _c('span', {
    staticClass: "epub-sans-sci"
  }, [_vm._v("E CALLS HIMSELF ")]), _vm._v("Foreman Prospect,” someone was saying.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Prometheus opened his eyes and saw that he was standing behind a short wooden gate and looked down upon by a woman wearing a black robe with a white collar.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“… but he doesn’t have any identification,” the man who was speaking continued.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Self-named Prospect could see that the middle-aged woman, his judge, found him fair. He could see in her eyes yellow sparks of passion that brought surprise to her face. How long had it been since this handsome, brown-skinned woman had felt her loins react to a man like she was a maiden.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“What is your name?” she asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Foreman Prospect … from Kansas City, Kansas,” he said, repeating words that he had practiced with Nosome Blane.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“And where do you live, Mr. Prospect?” the judge asked, her eyes reflecting the confusion in her fast blood.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“A small blue house at the corner of Crenshaw and Thirty-fifth, Your Honor,” Prometheus replied. Words were coming to him through the air. Somewhere he could hear the child Logos laughing. “I don’t know the number because I have only just made, um, arrangements to live there. My friend, Nosome Blane, is the landlord.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“And why don’t you have identification?” the judge asked, trying not to smile coyly.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I lost whatever I had, Your Honor. I’ve been away and haven’t needed a passage stone.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Your Honor,” the man standing next to the beautiful giant complained.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This man was also dark-skinned, though not so much as the woman judge. He seemed pained that Foreman was getting such mild treatment.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yes, Mr. Gordon?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“This man could be an illegal alien for all we know. We should at least make Homeland Security aware of him.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“He looks like an American,” the judge (her nameplate read Bohem) said. “He talks like an American.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“He was found walking half-naked down Sunset Boulevard,” the younger Gordon replied. “He resisted arrest. Officer Tynan sprained his ankle.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Mr. Prospect?” the judge asked solicitously.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I haven’t moved into my house yet, Judge Bohem. And living next to this big rock I guess my clothes … you know.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“And your resisting arrest?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I have no excuse,” Prometheus said. “I was confused I guess.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“More like high,” Prosecutor Gordon complained.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“You have his Breathalyzer results?” Anna Bohem asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“No, ma’am. After the struggle the officers were lucky to get this big fella into their vehicle.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“It says in the arrest record that Mr. Prospect was rendered unconscious,” the judge read, momentarily bringing reading glasses to her eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“They were fighting for their lives, ma’am.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“There’s no record of either officer being hospitalized.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“This man,” Gordon said, “is seven feet tall and strong.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Mr. Prospect,” Judge Bohem said.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yes, Your Honor.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“I am inclined to let you go home, but I expect you to return to my offices with papers proving your identity.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Your Honor,” Gordon complained. “I must object.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Mr. Gordon, this is my courtroom, is it not?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Yes, ma’am.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Bailiff,” the judge said then.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Your Honor,” an older, parchment-colored man said. He stood up from a chair against the far right wall.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Find some suitable clothes for the defendant and send him on his way. Make sure that he has the information to get in touch with me … to prove his citizenship. Is that satisfactory, Mr. Gordon?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The prosecutor mumbled something and Foreman Prospect was hustled from the court.")]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb2-n-s"
  }, [_c('span', {
    staticClass: "epub-sans-caps-i"
  }, [_vm._v("A")]), _c('span', {
    staticClass: "epub-sans-sci"
  }, [_vm._v("FTER THE HEARING ")]), _vm._v("Prometheus was shuttled from room to room. He was given clothes that were both too large and too small for his perfect frame. His blue jean pants needed a belt but didn’t go down as far as his ankles. His red checkered shirt was tight across his chest but loose around the middle. The shoes they gave him were rubber sandals without heels but he didn’t care.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He was asked to write his name and address on a long form that had much tiny writing upon it. Using the spirit of Ma’at he produced what he meant and what they would believe. Later the ancient Greek symbols would be indecipherable, but at that moment he was Foreman Prospect from the blue house at Thirty-fifth and Crenshaw.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("After two hours of processing, John Bolt, the ancient bailiff, handed the young giant two bills and said, “The judge wanted you to have this forty dollars. You don’t have to sign for it.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“How do I get to Thirty-fifth and Crenshaw from here?” Prometheus asked.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("“Bus right out in front of the court building.”")]), _vm._v(" "), _c('p', {
    staticClass: "sb-std"
  }, [_vm._v("*   *   *")]), _vm._v(" "), _c('p', {
    staticClass: "sb2"
  }, [_c('span', {
    staticClass: "epub-sans-caps-i"
  }, [_vm._v("E")]), _c('span', {
    staticClass: "epub-sans-sci"
  }, [_vm._v("ITHER IT WAS HIS SIZE ")]), _vm._v("or fair looks, or maybe it was his innocence that carried him to the street and to the door of the right bus. People showed him the way, forgave him for not having a pass or the right change, made room for him and chatted with him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Gazing at them, Foreman Prospect, recently the prisoner of Olympus, saw into their souls. He perceived that though these people were kind and helpful they all had the flaw of impoverished spirit; most, if not all, of them would go mad if he bestowed the Gift upon them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Mankind, he could see, had fallen on hard times much as he had. The suffering he endured for sharing the first gift had also been visited upon Man. They had been driven mad for suspecting a higher realm but being forever barred from knowing it.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e5ef39a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/001_chapter4.vue
// module id = 84
// module chunks = 0